import styled from '@emotion/styled/macro';
import { forPhoneOnly, Variables } from '@enter/core';
import { DateTypeSelect } from 'components';
import { PageLayoutHeader } from '../page-layout';

export const Header = styled(PageLayoutHeader)`
    ${forPhoneOnly(`
        flex-direction: column;
    `)};
`;

export const WrappedDateTypeSelect = styled(DateTypeSelect)`
    ${forPhoneOnly(`
        width: 100%;
    `)};
`;

export const WrappedDateRange = styled.div`
    display: flex;
    flex-direction: column;
    z-index: 2;
    background-color: ${Variables.Colors.white};
    margin: 0 25px;

    ${forPhoneOnly(`
        margin: 16px 0;
        flex-grow: 1
    `)};
`;

export const WrappedMessage = styled.div`
    display: inline-block;
    flex-grow: 1;
    text-align: right;
    font-size: 16px;
    line-height: 16px;
    margin-right: 16px;
    color: ${Variables.Colors.n30};
`;

export const Spacer = styled.div`
    display: flex;
    flex-grow: 1;
`;

export const ChildrenWrapper = styled.div`
    margin-left: 8px;
`;
